import en from '../lang/en.json';
import es from '../lang/es.json';
import fr from '../lang/fr.json';

const Translations = {
    en,
    es,
    fr
}

export const Localization = new class Localization {
    constructor() {
        this.lang = 'en';
        this.strings = Translations;
    }

    setLang(lang) {
        this.lang = Translations.hasOwnProperty(lang)
            ? lang
            : 'en';
    }

    getLang() {
        return this.lang;
    }

    getTranslatedString(key, tokens = {}) {
        const translationString = this.strings[this.lang].hasOwnProperty(key)
            ? this.strings[this.lang][key]
            : key;

        return this.replaceTokens(translationString, tokens);
    }

    // https://www.npmjs.com/package/just-template
    replaceTokens(string, data) {
        var proxyRegEx = /\{\{([^\}]+)?\}\}/g;
        return string.replace(proxyRegEx, function(_, key) {
            var keyParts = key.split('.');
            var value = data;
            for (var i = 0; i < keyParts.length; i++) {
                if (!value) return '';
                    value = value[keyParts[i]];
            }
            return value || '';
        });
    }

}

export function __(key, tokens = {}) {
    return Localization.getTranslatedString(key, tokens);
}
